/**
 * Ruta de la pantalla de login PROPIA.
 *
 * TALAPP-1862: acá vivía `getLoginUrl()`, que armaba a mano la URL de
 * autorización de Keycloak y a la que se redirigía ante cualquier 401. O sea
 * que un usuario con la sesión caída aterrizaba en la pantalla de Keycloak
 * —con otro branding y con los links "Register" y "Forgot password?" de
 * Keycloak a la vista— aunque la app tiene pantallas propias para las tres
 * cosas. Se eliminó por completo: que el símbolo no exista es lo que garantiza
 * que no quede ningún call site olvidado.
 *
 * El flujo Authorization Code que alimentaba, además, no tenía PKCE y usaba
 * `state = btoa(redirect_uri)` en vez de un nonce anti-CSRF. El cliente
 * `ava-app` ya no lo tiene habilitado.
 */
export const LOGIN_PATH = "/login";

/** Motivo por el que la sesión terminó, para explicárselo al usuario. */
export type SessionEndedReason =
  | "USER_LOGOUT"
  | "IDLE_TIMEOUT"
  | "ABSOLUTE_TIMEOUT"
  | "KEYCLOAK_BACKCHANNEL"
  | "KEYCLOAK_INACTIVE"
  | "ADMIN_REVOKE";

/**
 * URL de login con el motivo del corte, para que la pantalla lo explique.
 * El motivo real lo confirma el server (`/api/auth/session-status`); este
 * parámetro es solo una pista de la navegación.
 */
export const buildLoginUrl = (reason?: "expired" | "revoked"): string =>
  reason ? `${LOGIN_PATH}?reason=${reason}` : LOGIN_PATH;
